import type { BannerType } from '../types';

export function getCookieName(
	bannerType: BannerType | undefined,
	effectiveDate: string | undefined,
): string | undefined {
	if (!effectiveDate || !bannerType) return undefined;
	return `tos_banner_remaining_views_${bannerType}_${effectiveDate}`;
}
